/* eslint-disable import/no-anonymous-default-export */
export default {
  LOGIN_PAGE: "/login",
  HOME_PAGE: "/",
  PORTAL: "/portal",
  DASH_BOARD: "/dashboard",
  PORT_FOLIO: "/portfolio",
  NOT_FOUND_PAGE: "*",
};
